import React, { useEffect, useState, useRef } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import FieldArea from "../../../CustomComponents/FieldText";
import {
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore, storage } from "../../../../Firebase/config";

import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import * as Yup from "yup";
import { ModalBody } from "reactstrap";
import { updateProfile } from "../../../../redux/profile/action";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import CoverImages from "../../ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";
import AsteriskLabel from "../../../Common/AsteriskLabel";

// 🚀 Adjust this import path if your UploadLoader is located elsewhere
import UploadLoader from "../../../Common/Loader/UploadLoader";

const formdatatomap = [
  {
    title: (<>Upload CV <AsteriskLabel /></>),
    name: "cv",
    placeholder: "Drag and drop or Browse file",
  },
  {
    title: (<>Are you looking for full time job? <AsteriskLabel /></>),
    name: "full_time_job",
    placeholder: "full_time_job",
  },
  // { title: "Category", name: "category_id", placeholder: 'Category' },
  {
    title: (<>Current job title <AsteriskLabel /></>),
    name: "current_job_title",
    placeholder: "Enter Title",
  },
  {
    title: (<>Preferred work location <AsteriskLabel /></>),
    name: "work_location",
    placeholder: "work_location",
  },
  {
    title: (<>Are you open for part time job? <AsteriskLabel /></>),
    name: "part_time",
    placeholder: "part_time",
  },
  {
    title: (<>Price per hour in SAR</>),
    name: "price_per_hour",
    placeholder: "Enter Price per hour",
  },
  {
    title: (<>Price per month in SAR</>),
    name: "price_per_month",
    placeholder: "Enter Price per month",
  },
  {
    title: (<>Preferred work location <AsteriskLabel /></>),
    name: "work_location2",
    placeholder: "work_location2",
  },
  {
    title: (<>Preferred working country <AsteriskLabel /></>),
    name: "working_country",
    placeholder: "working_country",
  },
];

export default function ProfileModelPrice({
  edittype,
  formData,
  setFormData,
  setModelPrice,
}) {
  const [category, setCategory] = useState("");
  const [fulltime, setFulltime] = useState(1);
  const [parttime, setPartTime] = useState(1);
  const [country, setCountry] = useState("");
  const [selectCatgory, setselectCatgory] = useState(formData?.category_index1);
  
  // 🚀 Track the Firebase upload process
  const [isUploading, setIsUploading] = useState(false);

  const formikRef = useRef(null);
  const dispatch = useDispatch();
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [image, setImage] = useState(null);

  const initialValues = {
    cv: formData?.expert?.cv || formData?.cv || "",
    full_time_job:
      formData?.expert?.full_time_job || formData?.full_time_job || 1,
    category_id: formData?.expert?.category_id || formData?.category_id || "",
    current_job_title:
      formData?.expert?.current_job_title || formData?.current_job_title || "",
    work_location:
      formData?.expert?.work_location || formData?.work_location || 1,
    part_time: formData?.expert?.part_time || formData?.part_time || 1,
    price_per_hour:
      formData?.expert?.price_per_hour || formData?.price_per_hour || "",
    price_per_month:
      formData?.expert?.price_per_month || formData?.price_per_month || "",
    working_country: formData?.working_country || formData?.expert?.working_country || "",
    work_location2:
      formData?.expert?.work_location2 || formData?.work_location2 || 1,
  };

  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    setCategory(skillsss);
  }, [skillsss]);

  useEffect(() => {
    setCountry(countrylist);
  }, [countrylist]);

  const handleSubmit = async (values) => {
    if (image == null) {
      const data = {
        ...values,
        type: "expert_price",
      };
      if (edittype == 1) {
        dispatch(updateProfile(data));
        setModelPrice(false);
      } else {
        setFormData((prevData) => ({
          ...prevData,
          ...data,
        }));
        setModelPrice(false);
      }
    } else {
      // 🚀 Start loader
      setIsUploading(true);

      const image1Ref = ref(storage, `/Category/${image.name}`);
      const uploadTask1 = uploadBytesResumable(image1Ref, image);
      
      Promise.all([uploadTask1])
        .then(async () => {
          const url1 = await getDownloadURL(uploadTask1.snapshot.ref);
          const data = {
            ...values,
            cv: url1,
            type: "expert_price",
          };
          if (edittype == 1) {
            dispatch(updateProfile(data));
            setModelPrice(false);
          } else {
            setFormData((prevData) => ({
              ...prevData,
              ...data,
            }));
            setModelPrice(false);
          }
        })
        .catch((err) => {
          //urtoast(err.message, 2);
          console.error("Upload error: ", err);
        })
        .finally(() => {
          // 🚀 Stop loader
          setIsUploading(false);
        });
    }
  };

  const handleCategoryChange = (selectedOption, formik) => {
    setselectCatgory(selectedOption);
    formik.setValues({
      ...formik.values,
      category_index1: selectedOption,
      category_id: selectedOption.value,
    });
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const getValidationSchema = (values) => {
    if (fulltime == 1 && parttime == 1) {
      return Yup.object().shape({
        cv: Yup.string().required('You must upload at least one CV before saving.'),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job"
        ),
        current_job_title: Yup.string().required(
          "Current job title is required"
        ),
        work_location: Yup.string().required("Work location is required"),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job"
        ),
        price_per_hour: Yup.number()
          .required("Price per hour is required")
          .positive("Price must be positive"),
        price_per_month: Yup.number()
          .required("Price per month is required")
          .positive("Price must be positive"),
        working_country: Yup.number().required(
          "Preferred working country is required"
        ),
        work_location2: Yup.string().required("Title is required"),
      });
    } else if (fulltime == 1 && parttime != 1) {
      return Yup.object().shape({
        cv: Yup.string().required('You must upload at least one CV before saving.'),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job"
        ),
        work_location: Yup.string().required("Work location is required"),
        working_country: Yup.number().required(
          "Preferred working country is required"
        ),
      });
    } else if (parttime == 1 && fulltime !== 1) {
      return Yup.object().shape({
        cv: Yup.string().required('You must upload at least one CV before saving.'),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job"
        ),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job"
        ),
        price_per_hour: Yup.number()
          .required("Price per hour is required")
          .positive("Price must be positive"),
        price_per_month: Yup.number()
          .required("Price per month is required")
          .positive("Price must be positive"),
        work_location2: Yup.string().required(
          "Preferred work location is required"
        ),
        working_country: Yup.number().required(
          "Preferred working country is required"
        ),
      });
    } else if (parttime == 2 && fulltime == 2) {
      return Yup.object().shape({
        cv: Yup.string().required('You must upload at least one CV before saving.'),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job"
        ),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job"
        ),
      });
    } else if (parttime !== 1 && fulltime !== 1) {
      return Yup.object().shape({
        cv: Yup.string().required('You must upload at least one CV before saving.'),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job"
        ),
        current_job_title: Yup.string().required(
          "Current job title is required"
        ),
        work_location: Yup.string().required("Work location is required"),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job"
        ),
        price_per_hour: Yup.number()
          .required("Price per hour is required")
          .positive("Price must be positive"),
        price_per_month: Yup.number()
          .required("Price per month is required")
          .positive("Price must be positive"),
        working_country: Yup.number().required(
          "Preferred working country is required"
        ),
        work_location2: Yup.string().required("Title is required"),
      });
    } else {
      return Yup.object().shape({
        cv: Yup.string().required('You must upload at least one CV before saving.'),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job"
        ),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job"
        ),
      });
    }
  };

  return (
    <>
      <button
        onClick={() => setModelPrice((state) => !state)}
        className="btn close-button"
        disabled={isUploading}
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="Close"
        />
      </button>
      
      <ModalBody className="position-relative">
        
        {/* 🚀 Show Loader inside the modal body when uploading */}
        {isUploading && <UploadLoader />}
        
        <div className={isUploading ? "opacity-50 pointer-events-none" : ""}>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={(values) => getValidationSchema(values)}
            enableReinitialize={true}
            innerRef={formikRef}
          >
            {(formik) => (
              <Form>
                <div>
                  {formdatatomap.map((prop, key) => {
                    if (prop.name == "full_time_job") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="margin-head mt-3">{prop.title}</h6>
                          <div className="checkbox-label">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="1"
                                checked={formik.values[prop.name] == "1"}
                                onChange={(e) => {
                                  setFulltime(1);
                                  formik.setFieldValue(prop.name, "1");
                                }}
                                disabled={isUploading}
                              />
                              <span className="checkmark">Yes</span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="2"
                                checked={formik.values[prop.name] == "2"}
                                onChange={(e) => {
                                  setFulltime(2);
                                  formik.setFieldValue(prop.name, "2");
                                }}
                                disabled={isUploading}
                              />
                              <span className="checkmark">No</span>
                            </label>
                          </div>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }
                    if (prop.name == "category_id") {
                      if (
                        prop.name == "category_id" &&
                        formik.values.full_time_job == 1
                      ) {
                        return (
                          <div className="form-group" key={key}>
                            <label>Category</label>
                            <ReactSelect
                              options={
                                Array.isArray(category) &&
                                category.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              placeholder="Select Category"
                              value={selectCatgory}
                              onChange={(options) => {
                                handleCategoryChange(options, formik);
                              }}
                              isDisabled={isUploading}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "current_job_title") {
                      if (
                        prop.name == "current_job_title" &&
                        formik.values.full_time_job == 1
                      ) {
                        return (
                          <FieldInput
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                            disabled={isUploading}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "work_location") {
                      if (
                        prop.name == "work_location" &&
                        formik.values.full_time_job == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="work-title">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="1"
                                  checked={formik.values[prop.name] == "1"}
                                  disabled={isUploading}
                                />
                                <span className="checkmark">Virtual </span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="2"
                                  checked={formik.values[prop.name] == "2"}
                                  disabled={isUploading}
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }

                    if (prop.name == "cv") {
                      return (
                        <div key={key}>
                          <h6 className="add-edu">{prop.title}</h6>
                          {/* Note: CoverImages might need an `isUploading` or `disabled` prop passed to it depending on its internal logic */}
                          <CoverImages
                            formik={formik}
                            type={'single'}
                            name={prop.name}
                            title={prop.title}
                          />
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }

                    if (prop.name == "part_time") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="margin-head">{prop.title}</h6>
                          <div className="checkbox-label">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="1"
                                checked={formik.values[prop.name] == 1}
                                onChange={(e) => {
                                  setPartTime(1);
                                  formik.setFieldValue(prop.name, 1);
                                }}
                                disabled={isUploading}
                              />
                              <span className="checkmark">Yes</span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="2"
                                checked={formik.values[prop.name] == 2}
                                onChange={(e) => {
                                  setPartTime(2);
                                  formik.setFieldValue(prop.name, 2);
                                }}
                                disabled={isUploading}
                              />
                              <span className="checkmark">No</span>
                            </label>
                          </div>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }
                    if (prop.name == "price_per_hour") {
                      if (
                        prop.name == "price_per_hour" &&
                        formik.values.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            type={"number"}
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                            disabled={isUploading}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "price_per_month") {
                      if (
                        prop.name == "price_per_month" &&
                        formik.values.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            type={"number"}
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                            disabled={isUploading}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "work_location2") {
                      if (
                        prop.name == "work_location2" &&
                        formik.values.part_time == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="work-title">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="1"
                                  checked={formik.values[prop.name] == "1"}
                                  disabled={isUploading}
                                />
                                <span className="checkmark">Virtual</span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="2"
                                  checked={formik.values[prop.name] == "2"}
                                  disabled={isUploading}
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "working_country") {
                      if (
                        prop.name == "working_country" &&
                        (formik.values.part_time == 1 ||
                          formik.values.full_time_job == 1)
                      ) {
                        return (
                          <div className="form-group" key={key}>
                            <h6 className="work-title">{prop.title}</h6>
                            <ReactSelect
                              options={
                                Array.isArray(country) &&
                                country.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              name="working_country"
                              id="working_country"
                              placeholder="Select country"
                              value={
                                Array.isArray(country) &&
                                country
                                  .map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                  .find(
                                    (option) =>
                                      option.value ==
                                      formik.values.working_country
                                  )
                              }
                              onChange={(options) => {
                                formik.setFieldValue(
                                  "working_country",
                                  options.value
                                );
                              }}
                              isDisabled={isUploading}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }

                    if (prop.name == "about") {
                      return (
                        <FieldArea
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                          disabled={isUploading}
                        />
                      );
                    }

                    return (
                      <FieldInput
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                        disabled={isUploading}
                      />
                    );
                  })}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button 
          className="btn" 
          onClick={handleNextClick} 
          disabled={isUploading}
        >
          {isUploading ? "Saving..." : "Save"}
        </button>
      </div>
    </>
  );
}